import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractIAImportProcess } from '../../../models/Entities/Contracts/ContractIAImportProcess';

/*
 * While an import runs, the widget polls GETLAST every few seconds. Rebuilding the
 * contract and the contract list on every response replaced their identities even
 * when the process had not moved, which re-rendered everything hanging from the
 * contract and re-fired the effects keyed on it - the stages of the addendum were
 * being refetched on every poll because of this. New state is produced only when
 * the process really changed.
 */
const isSameProcess = (
  stored: ContractIAImportProcess | undefined,
  incoming: ContractIAImportProcess | undefined
): boolean => {
  if (stored === incoming) return true;
  if (!stored || !incoming) return false;
  return JSON.stringify(stored) === JSON.stringify(incoming);
};

export default function ContractIAImportReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;

  switch (action.type) {
    case 'CONTRACT_IAIMPORT_CREATE_SUCCESS': {
      const a: any = action;
      const process = a.process;
      if (!process || !process.contractID) return currentState;
      
      const contractId: number = process.contractID;
      const CurrentContract: Contract | undefined = currentState.list?.find((item: Contract) => item.id === contractId);
      if (!CurrentContract) return currentState;
      if (isSameProcess(CurrentContract.lastIAImportProcess, process)) return currentState;
      
      const updated: Contract = { ...CurrentContract, lastIAImportProcess: process };
      return {
        ...currentState,
        list: [...(currentState.list || []).filter((item: Contract) => item.id !== contractId), updated],
      };
    }
    case 'CONTRACT_IAIMPORT_GETLAST_SUCCESS': {
      const a: any = action;
      const contractId: number = a.contractId;
      const process = a.process || undefined;
      const CurrentContract: Contract | undefined = currentState.list?.find((item: Contract) => item.id === contractId);
      if (!CurrentContract) return currentState;
      if (isSameProcess(CurrentContract.lastIAImportProcess, process)) return currentState;
      const updated: Contract = { ...CurrentContract, lastIAImportProcess: process };
      return {
        ...currentState,
        list: [...(currentState.list || []).filter((item: Contract) => item.id !== contractId), updated],
      };
    }
    default:
      return currentState;
  }
}
